import { FleetTireAddRow } from "services/api/fleet/tires/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import { TIRE_TYPE_BACKGROUND } from "ui/modules/fleet/tires/pages/TireSetSearchPage/components/TireSetSearchResults/consts";
import Badge from "ui/components/Badge/Badge";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";

export const TIRE_SET_TIRES_COLUMNS = (
    t: (key: string) => string
): Column[] => [
        {
            title: "",
            field: "",
            type: ColumnTypes.custom,
            render: (row: FleetTireAddRow) => {

                const initials = (row.tireManufacturer?.name ?? "").charAt(0).toUpperCase();
                return <TableIcon initials={initials} />;
            },
        },
        {
            title: t("admin.fleet.tire.add.width"),
            field: "",
            type: ColumnTypes.custom,
            render: (row: FleetTireAddRow) => <span className="text-sm">{row.width ?? "-"}</span>,
        },
        {
            title: t("admin.fleet.tire.add.height"),
            field: "",
            type: ColumnTypes.custom,
            render: (row: FleetTireAddRow) => <span className="text-sm">{row.height ?? "-"}</span>,
        },
        {
            title: t("admin.fleet.tire.add.radius"),
            field: "",
            type: ColumnTypes.custom,
            render: (row: FleetTireAddRow) => <span className="text-sm">{row.radius ?? "-"}</span>,
        },
        {
            title: t("admin.fleet.tire.add.manufacturer"),
            field: "",
            type: ColumnTypes.custom,
            render: (row: FleetTireAddRow) => <span className="text-sm">{row.tireManufacturer?.name ?? "-"}</span>,
        },
        {
            title: t("admin.fleet.tire.add.tiretype"),
            field: "",
            type: ColumnTypes.custom,
            render: (row: FleetTireAddRow) => (
                <div className="flex gap-1.5 items-center text-sm">
                    {row.tireType && TIRE_TYPE_BACKGROUND(row.tireType.id)}
                    {row.tireType?.name ?? "-"}
                </div>
            ),
        },
        {
            title: t("admin.fleet.tire.add.dot"),
            field: "",
            type: ColumnTypes.custom,
            render: (row: FleetTireAddRow) => <span className="text-sm">{row.dot && row.dot > 0 ? row.dot : "-"}</span>,
        },
        {
            title: t("admin.fleet.tire.add.profiledepth"),
            field: "",
            type: ColumnTypes.custom,
            render: (row: FleetTireAddRow) => <span className="text-sm">{row.profileDepth && row.profileDepth > 0 ? `${row.profileDepth}` : "-"}</span>,
        },
        {
            title: t("admin.fleet.tire.add.rof"),
            field: "",
            type: ColumnTypes.custom,
            render: (row: FleetTireAddRow) => row.rof ? <Badge text="ROF" variant="info" height="small" /> : <span className="text-sm">-</span>,
        },
    ];
